export default "__VITE_ASSET__LLpweu0K__"